var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 66,
    viewBox: "0 0 70 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_851_9432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.000759065 8.92773C-0.020387 7.75152 0.201207 6.58379 0.650297 5.49688C1.09939 4.40997 1.76641 3.42702 2.61005 2.60891C3.42635 1.76553 4.40657 1.09881 5.49016 0.64995C6.57375 0.201092 7.73768 -0.0203702 8.91005 -0.000755242C10.099 -0.0138292 11.2785 0.210794 12.3798 0.659973C13.481 1.10915 14.4818 1.77387 15.3236 2.61523C16.1943 3.41795 16.8865 4.39558 17.3548 5.48434C17.8231 6.57311 18.0571 7.74856 18.0416 8.93405C18.0563 10.1194 17.822 11.2946 17.3537 12.3833C16.8854 13.4719 16.1937 14.4496 15.3236 15.2529C14.4815 16.0934 13.4805 16.7571 12.3792 17.2052C11.278 17.6533 10.0986 17.8768 8.91005 17.8625C7.73657 17.8834 6.57133 17.6625 5.48654 17.2136C4.40175 16.7647 3.42055 16.0973 2.60375 15.2529C1.76107 14.433 1.09516 13.4487 0.647181 12.3608C0.199204 11.2729 -0.0213193 10.1044 -0.000759065 8.92773Z",
    fill: "#E02125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7793 65.9999H53.6919V63.82C53.709 61.5957 53.342 59.3852 52.6072 57.2863C51.897 55.2619 50.7883 53.4011 49.3469 51.8142C48.9227 51.1021 48.3711 50.4745 47.7198 49.9628C47.068 49.4617 46.4506 48.9171 45.8721 48.3325C44.3091 47.3307 42.6297 46.5244 40.8712 45.9314C39.0378 45.3399 37.1215 45.0476 35.1955 45.0657C32.7661 45.0405 30.3573 45.5142 28.1177 46.4575C25.878 47.4007 23.8548 48.7937 22.173 50.5504C20.4113 52.2736 19.0202 54.3398 18.0853 56.6219C17.1504 58.9039 16.6916 61.3535 16.737 63.82V65.9999H0.87029C0.7066 65.5005 0.625649 64.9775 0.630651 64.4518V62.7331C0.630651 52.8589 3.97089 44.5076 10.6514 37.679C17.3319 30.8505 25.5301 27.4383 35.246 27.4426C39.8258 27.3755 44.3709 28.2492 48.6008 30.0097C52.8308 31.7703 56.656 34.3804 59.8406 37.679C63.1347 40.9052 65.7354 44.7725 67.4825 49.0431C69.2297 53.3137 70.0864 57.8973 70 62.512C69.9989 63.0949 69.9631 63.6773 69.8928 64.256C69.8173 64.8342 69.7794 65.4168 69.7793 65.9999Z",
    fill: "#E02125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 0.87207H32.1748V16.7702H70V0.87207Z",
    fill: "#E02125"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_851_9432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 66,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic-error.780d3a644b2e0744e7555c258b6a0c55.svg";
export { ForwardRef as ReactComponent };